module.exports = __webpack_public_path__ + "img/l2.4fa94d97.jpg";